export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";